// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"18":"product","646":"introduce","781":"logo"}[chunkId] + "." + {"18":"6426e067","646":"612df044","781":"8441749e"}[chunkId] + ".css";
};